// Packages
import React, { useEffect, useState } from "react";

import useTableInstance from "hooks/useTableInstance";
import { createColumnHelper } from "@tanstack/react-table";
import { useTheme } from "@mui/material/styles";

// Components
import { Box, Button, Typography } from "@mui/material";
import ModalContainer from "components/ModalContainer";
import TableField from "components/Table";
import PendingChildren from '../PendingChildren';

// Img
import { ReactComponent as CloseIcon } from "assets/images/icons/icn_close.svg";

// Helper
import { initDevicesTableData } from "../../helper";

// Const
import { getDevicesModalColumn } from "../../const";

const DevicesModal = ({
  selectedDevices,
  setSelectedDevices,
  isOpenDeviceModal,
  setIsOpenDeviceModal,
}) => {
  const theme = useTheme();
  const columnHelper = createColumnHelper();
  const demoDevice = selectedDevices?.[0];
  const [isLoading, setIsLoading] = useState(false);

  const devicesTableInstance = useTableInstance({
    tableName: "firmwareDevicesModalTable",
    data: selectedDevices,
    enablePagination: true,
    columns: getDevicesModalColumn({
      columnHelper,
    }),
  });

  const handleResetModal = () => {
    setIsLoading(false);
    setSelectedDevices([]);
  }

  useEffect(() => {
    setIsLoading(true);

    const devices = initDevicesTableData({
      selectedDevices
    });
    setSelectedDevices(devices);

    setIsLoading(false);

    return () => {
      handleResetModal();
    }
  }, [])

  return (
    <ModalContainer display={!!isOpenDeviceModal} modalWidth={"1250px"}>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>

        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontSize: theme.typography.customFontSize[5],
            fontWeight: theme.typography.customFontWeight[3],
          }}>
          {demoDevice?.modelName ? `Device ${demoDevice.modelName}` : "-"}
        </Typography>

        <Button
          onClick={() => setIsOpenDeviceModal(false)}
          sx={{
            backgroundColor: theme.palette.primary.transparent,
            boxShadow: "none",
            "&:hover": {
              backgroundColor: theme.palette.primary.transparent,
            },
          }}>
          <CloseIcon />
        </Button>

      </Box>

      <Box sx={{ marginBottom: "20px" }}>
        <TableField
          {...devicesTableInstance}
          pendingChildren={
            <PendingChildren
              {...{
                isLoading,
                list: selectedDevices,
                description: "No data."
              }}
            />
          }
        />
      </Box>
    </ModalContainer>
  );
};

export default DevicesModal;